// @ts-nocheck
import Paper from 'paper';
import { ImageSharedModels } from '@medsurf/flat-models';
import { Container } from '../container';
import { Element } from '../element';

/**
 * Image class
 */
export class Sprite<T extends ImageSharedModels.SpriteModel> extends Element<T> {
  protected _image: Paper.Raster;
  private _originalImageWidth: number;
  private _originalImageHeight: number;

  /**
   * Constructor
   * @param model
   * @param _localPaper
   * @param _mainLayer
   * @param _container
   */
  public constructor(
    model,
    private _localPaper: Paper.PaperScope,
    private _mainLayer: Paper.Layer,
    private _container: Container
  ) {
    super(model);
    this._init();
  }

  /**
   * Init
   *
   * @protected
   */
  protected _init() {
    this._element = new Paper.Group();
    this.state = 'hidden';
    this._mainLayer.addChild(this._element);
  }

  /**
   * Load image file from server
   *
   * @param name
   */
  doLoadFile(path: string) {
    this._element.sprite = this;
    this._image = new Paper.Raster(
      path,
      new Paper.Point(
        this._model.offset.x,
        this._model.offset.y
      )
    );

    this._image.sprite = this;

    this._element.addChild(this._image);
    this._image.onLoad = () => {
      this.state = 'visible';
      this._originalImageWidth = this._image.width;
      this._originalImageHeight = this._image.height;
      this._image.pivot = new Paper.Point(this._image.width * -0.5, this._image.height * -0.5);
      this.arrange();
      this.emit('created');
    };
  }

  /**
   * Draw -> arrange
   */
  draw() {
    this.arrange();
  }

  /**
   * Resize
   *
   * @param width
   * @param height
   */
  resize(width, height) {
    width = this._originalImageWidth;
    height = this._originalImageHeight;
  }

  /**
   * Set posititon
   */
  arrange() {
    if (this._image) {
      this._image.setPosition(this._model.offset.x, this._model.offset.y);
    }
    this.state = this._state;
  }

  /**
   * Clean up element
   */
  cleanUp() {
    this._element.removeChildren();
    super.cleanUp();
  }

  /**
   * Getter scale
   *
   * @returns {*}
   */
  get scale() {
    return this.model.scale;
  }

  /**
   * Getter pixels
   *
   * @returns {*|number}
   */
  get pixels() {
    return this._element.getPixel(1, 1);
  }
}
